const fromPathname2Pathname: Record<string, string> = {
  '/activity-manage/merchants': '/activity-manage/list',
  '/activity-manage/detail': '/activity-manage/list',
  '/activity-manage/create': '/activity-manage/list',
  '/activity-manage/proSalesData': '/activity-manage/list',
};
// 活动管理层级去除导致活动详情无法匹配提到顶级的主题活动
// 重定向活动详情的高亮到主题活动下
function redirectDetailToActivityList(prevPathname: string, childPathname: string) {
  // /activity-manage/merchants/
  // /activity-manage/detai
  if (prevPathname && !prevPathname.includes('/activity-manage')) return prevPathname;

  // 招商活动和1.0活动详情
  const matchedKey = Object.keys(fromPathname2Pathname).find((key) => childPathname.indexOf(key) === 0);

  if (!matchedKey) return prevPathname;

  return fromPathname2Pathname[matchedKey];
}

export default redirectDetailToActivityList;
